import useSectionData from './useSectionData';
import { SECTION_ENDPOINTS } from '@/Services/sectionApi';
import { sectionErrors } from '@/data/content';

interface FooterSectionData {
    restaurant: {
        name?: string;
    };
    footer_links: unknown[];
    social_links: {
        instagram?: string;
        facebook?: string;
    };
}

const initialFooter: FooterSectionData = {
    restaurant: {},
    footer_links: [],
    social_links: {},
};

const useFooterData = () => useSectionData(SECTION_ENDPOINTS.footer, initialFooter, sectionErrors.footer);

export default useFooterData;
